import { Component, OnInit } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { DBService } from '../db.service';

import { slide } from '../animations';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    slide
  ]
})
export class LoginComponent implements OnInit {
  loginError = false;
  loggingIn = false;
  email: string;
  password: string;

  constructor(
    private afAuth: AngularFireAuth,
    private dbService: DBService
  ) { }

  ngOnInit() {
  }

  login() {
    this.loggingIn = true;
    this.afAuth.auth.signInWithEmailAndPassword(this.email, this.password)
                    .catch(err => {
                      console.log('Login Error', err);
                      this.loginError = true;
                      this.loggingIn = false;
                    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts